"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvironment = void 0;
const getEnvironment = () => {
    const match = /(([\w]+)\.)?autopay\.io/.exec(window.location.hostname);
    if (!match) {
        return 'test';
    }
    if (match.length > 2 && match[2]) {
        if (match[2] === 'test' || match[2] === 'qa') {
            return match[2];
        }
    }
    return 'prod';
};
exports.getEnvironment = getEnvironment;
//# sourceMappingURL=getEnvironment.js.map